import React from 'react';
import { XIcon } from 'lucide-react';
type LegalModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: React.ReactNode;
};
export function LegalModal({
  isOpen,
  onClose,
  title,
  content
}: LegalModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" data-id="element-235">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] overflow-hidden flex flex-col animate-fade-in-up" data-id="element-236">
        <div className="flex justify-between items-center p-4 border-b" data-id="element-237">
          <h3 className="text-lg font-bold" data-id="element-238">{title}</h3>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700" data-id="element-239">
            <XIcon className="h-5 w-5" data-id="element-240" />
          </button>
        </div>
        <div className="p-6 overflow-y-auto" data-id="element-241">{content}</div>
        <div className="border-t p-4 text-right" data-id="element-242">
          <button onClick={onClose} className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors" data-id="element-243">
            Cerrar
          </button>
        </div>
      </div>
    </div>;
}